import { openaiUsage } from "../openai/usage";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const perplexity = defineConnector({
  identifier: "perplexity",
  name: "Perplexity",
  tagLine: "AI-powered search and answer engine",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: () => "https://api\\.perplexity\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Perplexity API Settings](https://www.perplexity.ai/settings/api) and generate an API key.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.perplexity.ai/chat/completions",
  },
  usage: openaiUsage(),
});
